import { AdminToken } from '_constants';
import { useEffect, useState } from 'react';

const ADMIN_TOKEN_CHANGED = 'admin-token-changed';

export function useAdminJwt() {
  const read = () =>
    typeof window === 'undefined' ? null : localStorage.getItem(AdminToken);

  const [token, setTokenState] = useState<string | null>(read);

  // Sync across tabs/windows
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.storageArea === localStorage && e.key === AdminToken) {
        setTokenState(e.newValue);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // Sync within the same tab when we update localStorage ourselves
  useEffect(() => {
    const onLocal = (_e: Event) => setTokenState(read());
    window.addEventListener(ADMIN_TOKEN_CHANGED, onLocal);
    return () => window.removeEventListener(ADMIN_TOKEN_CHANGED, onLocal);
  }, []);

  const setToken = (next: string | null) => {
    if (typeof window === 'undefined') return;

    if (!next) localStorage.removeItem(AdminToken);
    else localStorage.setItem(AdminToken, next);

    // 'storage' doesn't fire in the same tab; use a custom event
    window.dispatchEvent(new Event(ADMIN_TOKEN_CHANGED));
  };

  const clearToken = () => setToken(null);

  return { token, setToken, clearToken };
}
